import React from "react";
import { Box, SimpleGrid, Text, VStack, useColorModeValue } from "@chakra-ui/react";
import { formatDateTime, getRequesterName } from "../../utils/riskReviewFormatters";

const formatLabel = (value) => {
  if (!value) return "—";
  return String(value)
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const item = (label, value) => (
  <Box>
    <Text color="gray.500" fontSize="xs" fontWeight="600">
      {label}
    </Text>
    <Text color="gray.800" fontSize="sm" fontWeight="700">
      {value || "—"}
    </Text>
  </Box>
);

const getValue = (values, request, fieldCode, requestKey) => {
  const fieldCodes = Array.isArray(fieldCode) ? fieldCode : [fieldCode];
  const liveValue = fieldCodes
    .map((code) => values?.[code])
    .find((value) => value !== undefined && value !== null && value !== "");

  if (liveValue !== undefined) {
    return liveValue;
  }

  return request?.[requestKey];
};

const RiskReviewRequestSummary = ({ request, template, values = {} }) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Box bg={cardBg} border="1px solid" borderColor={borderColor} borderRadius="xl" overflow="hidden">
      <Box px={4} py={3} borderBottom="1px solid" borderColor="gray.100">
        <Text color="gray.800" fontWeight="700">
          Request Summary
        </Text>
      </Box>
      <Box px={4} py={4}>
        <VStack align="stretch" spacing={3}>
          <SimpleGrid columns={2} spacing={3}>
            {item("Status", formatLabel(request?.status))}
            {item("Revision", request?.revisionNo ?? 0)}
            {item("Type", formatLabel(request?.requestType))}
            {item("Country", getValue(values, request, ["CUSTOMER_COUNTRY", "COUNTRY"], "country"))}
            {item("Business Unit", getValue(values, request, "BUSINESS_UNIT", "businessUnit"))}
            {item("Division", getValue(values, request, "DIVISION", "division"))}
          </SimpleGrid>
          <Box borderTop="1px solid" borderColor="gray.100" pt={3}>
            {item("Requester", getRequesterName(request))}
          </Box>
          <Box borderTop="1px solid" borderColor="gray.100" pt={3}>
            {item("Submitted", formatDateTime(request?.submittedAt))}
          </Box>
          <Box borderTop="1px solid" borderColor="gray.100" pt={3}>
            {item("Template Version", template?.version ? `v${template.version}` : request?.templateVersion ? `v${request.templateVersion}` : "—")}
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};

export default RiskReviewRequestSummary;
